<template>
    <div class="acomodar">
        <SeguiRotacion/>
    </div>
</template>

<script>
import SeguiRotacion from '@/components/ModTecnologia/RotacionDispositivo/SeguiRotacion.vue';
import '@/assets/styles/global-acomodar.css'; // Importar el estilo global
export default {
    name: 'SeguimientoRotacion',
    components:{
        SeguiRotacion
    },

     data() {
    return {
      
    };
  },

  mounted() {
    
  },

  created(){
    this.cambiarEstadoNavbar()
  },

   methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
  },
};
</script>

<style scoped>


</style>